export default __webpack_public_path__ + "static/zaptheory-182a6026eb9a1296fbbd387a430a333a.png";